import axios from "axios";
import { EntityServices } from "@sdk/utils/entity.service";
import type { PaginatedOptions, PaginatedResults } from "@sdk/utils/paginated-results";
import type { iProfitAllocationRecord } from "./profit-allocation-record-model";

export type ProfitAllocationReportRowV2 = iProfitAllocationRecord & {
  booking: {
    id: string;
    shortId: number;
    createdAt: number;
    owner: string;
    customerId: string;
  };
};

export class ProfitAllocationRecordsServices {
  configure(config: { basePath?: string; token?: string }) {
    Object.assign(this.config, config);
    this.profitAllocationRecords.configure(config);
  }

  constructor(protected config: { basePath: string; token: string }) {
    this.profitAllocationRecords = Object.assign(
      new EntityServices<iProfitAllocationRecord>(
        config,
        "profit-allocation-records",
        {}
      ),
      {
        report: async (body: {
          query?: Record<string, unknown>;
          options?: PaginatedOptions;
        }): Promise<PaginatedResults<ProfitAllocationReportRowV2>> => {
          const results = await axios.post<
            PaginatedResults<ProfitAllocationReportRowV2>
          >(config.basePath + `/profit-allocation-records/report`, body, {
            headers: { Authorization: config.token },
          });
          return results.data;
        },
      }
    );
    this.profitAllocationRecords.configure(config);
  }

  profitAllocationRecords!: EntityServices<iProfitAllocationRecord> & {
    report: (body: {
      query?: Record<string, unknown>;
      options?: PaginatedOptions;
    }) => Promise<PaginatedResults<ProfitAllocationReportRowV2>>;
  };
}
